import { useCallback, useEffect, useState } from "react";
import useFixedAcceptorEmail from "./useFixedAcceptorEmail";
import { constants } from "entities/RequestBasicDetails";

const { additionalAcceptanceFieldStateDefaultValues } = constants.basicDetails;

const defaultOptions = {
  shouldDirty: true,
  shouldValidate: true,
};

const useAdditionalAcceptorField = (
  form,
  dependencies,
  advancePayment,
  requestorEmail
) => {
  const { setValue, watch, resetField } = form;

  const representation = watch("representation_id");
  const costCentre = watch("cost_centre");
  const supervisorEmail = watch("supervisor_email");
  const additionalAcceptorEmail = watch("additional_acceptor_email");

  const fixedAcceptorEmail = useFixedAcceptorEmail(costCentre, [
    supervisorEmail,
    requestorEmail,
  ]);

  const [additionalAcceptorFieldState, setAdditionalAcceptorFieldState] =
    useState(additionalAcceptanceFieldStateDefaultValues);

  const toggleAdditionalAcceptorField = useCallback(() => {
    setAdditionalAcceptorFieldState({
      ...additionalAcceptorFieldState,
      open: !additionalAcceptorFieldState.open,
    });
  }, [additionalAcceptorFieldState.open]);

  useEffect(() => {
    if (advancePayment) return;

    if (fixedAcceptorEmail !== null) {
      setAdditionalAcceptorFieldState({ open: true, disabled: true });
      setValue("additional_acceptor_email", fixedAcceptorEmail, defaultOptions);
    } else if (additionalAcceptorEmail !== null) {
      setAdditionalAcceptorFieldState({ open: true, disabled: false });
      setValue("additional_acceptor_email", additionalAcceptorEmail);
    } else if (
      additionalAcceptorEmail === null ||
      fixedAcceptorEmail === null
    ) {
      setAdditionalAcceptorFieldState(
        additionalAcceptanceFieldStateDefaultValues
      );
    }
  }, [
    additionalAcceptorEmail,
    advancePayment,
    representation,
    dependencies,
    fixedAcceptorEmail,
  ]);

  useEffect(() => {
    if (advancePayment) return;
    if (
      additionalAcceptorFieldState.open === false &&
      additionalAcceptorEmail !== null
    ) {
      setValue("additional_acceptor_email", null, defaultOptions);
    } else resetField("additional_acceptor_email");
  }, [additionalAcceptorFieldState.open, advancePayment]);

  return {
    additionalAcceptorFieldState,
    setAdditionalAcceptorFieldState,
    toggleAdditionalAcceptorField,
  };
};

export default useAdditionalAcceptorField;
